/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  userListWrap: {
    width: "100%",
    height: "100%",
    overflow: "scroll",
    "& thead p": {
      fontSize: "0.875rem",
      fontWeight: "bold",
    },
  },
  leftArrowIcon: {
    color: theme.palette.text.secondary,
  },
  actionIcon: {
    minWidth: "auto",
    marginRight: Tokens.spacing['$sp-3']
  },
  userMenuItemBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  cellText: {
    fontSize: "0.875rem",
    color: theme.palette.text.primary,
  },
  icon: {
    color: theme.palette.text.secondary,
    marginRight: Tokens.spacing['$sp-2']
  }
}));
